import { useCommonStore } from '@/stores/commonStore'
import { loadLocaleMessages } from '@/helpers/setup-i18n'
import { useCmsStore } from '@/stores/cmsStore'
import { useI18n } from 'vue-i18n'

export function useLanguages() {
  const langStore = useCmsStore()
  const i18n = useI18n()
  const commonStore = useCommonStore()
  const changeLanguage = async (value) => {
    await langStore.getProductionTipByLocale(value)
    await loadLocaleMessages(i18n, value)
    i18n.locale.value = value
  }

  const getIriByLocale = (locale) => {
    return commonStore.languages.find((lan) => {
      return lan.locale.substr(0, 2) === locale
    }).id
  }

  return {
    getIriByLocale,
    changeLanguage
  }
}
